<template>
  <path
    class="LinePath"
    :d="d"
    :stroke="stroke"
    :stroke-width="lineSize"
    fill="none"
  />
</template>

<script>
export default {
  name: 'DatalasLinePath',
  inheritAttrs: false,
  props: {
    fill: {
      type: String,
    },
    data: {
      type: Array,
      default: () => [],
    },
    lineSize: {
      type: Number,
      default: 1.5,
    },
    xAccessor: {
      type: Function,
    },
    yAccessor: {
      type: Function,
    },
    xScale: {
      type: Function,
    },
    yScale: {
      type: Function,
    },
    bandwidth: {
      type: Number,
      default: 0,
    },
    y0: {
      type: Number,
      default: 0,
    },
    stroke: {
      type: String,
    },
    curve: Boolean,
  },
  computed: {
    d() {
      // If the x scale is bands, interpret each point as a step as wide as the
      // band. This is done by adding redundant data points and adding
      // `bandwidth` to their x value.
      const { data, xScale, xAccessor, bandwidth } = this;
      const pathData = bandwidth
        ? data.reduce((acc, d) => [...acc, d, d], [])
        : data;

      const line = this.$d3
        .line()
        .x((d, i) => xScale(xAccessor(d)) + (i % 2 ? bandwidth : 0))
        .y((d) => this.yScale(this.yAccessor(d)));

      if (this.curve) {
        line.curve(this.$d3.curveMonotoneX)(pathData);
      }
      return line(pathData);
    },
  },
};
</script>
